
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 90 90"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"new_box_svg__a"}},[_c('path',{attrs:{"fill":"none","d":"M7.61 13.67h74v64h-74z"}})]),_c('clipPath',{attrs:{"id":"new_box_svg__b"}},[_c('path',{attrs:{"fill":"none","clip-path":"url(#new_box_svg__a)","clip-rule":"evenodd","d":"M52.84 75.83l-18.37 1.36V17.13l18.37-2.04v60.74z"}})])]),_c('g',{attrs:{"clip-path":"url(#new_box_svg__b)"}},[_c('path',{attrs:{"fill":"#ffd04f","d":"M29.47 10.09h28.37v72.1H29.47z"}})]),_c('path',{attrs:{"d":"M12.93 25.24v50l61.8-1-1-48.91zM9 15v10.2h70.5L78 15.94 9 15zm28 .39v59.37M18.9 31.13v38.06","fill":"none","stroke":"#000","stroke-miterlimit":"10","stroke-width":"2.057"}})])
          )
        }
      }
    